import BonusesTab from 'pages/Desktop/Home/Manager/components/Bonuses/BonusesTab'

export const ropTabsList = [
  { label: 'Бонусы', component: BonusesTab }
]
